<template>
	<section class="flex">
		<section class="common-sub-top container">
			<section class="top-info-wrap">
				<div class="prev-wrap">
					<a @click="pageBefore()" class="prev"></a>
					<span class="name">서식지 정렬 기준</span>
				</div>

				<div class="select-wrap">
					<div class="select" @click="changeSort">저장</div>
				</div>
			</section>
		</section>

		<section class="content sortform">
			<div class="li">
				<div class="radio-group">
					<input type="radio" id="targetName" name="targetRadio" value="name" v-model="sortNm" />
					<label for="targetName">이름순</label>
				</div>
				<div class="radio-group">
					<input type="radio" id="targetCreated" name="targetRadio" value="date" v-model="sortNm" />
					<label for="targetCreated">생성순</label>
				</div>
			</div>
			<div class="li">
				<div class="radio-group">
					<input type="radio" id="sortASC" name="sortRadio" value="asc" v-model="sortGb" />
					<label for="sortASC">오름차순</label>
				</div>
				<div class="radio-group">
					<input type="radio" id="sortDESC" name="sortRadio" value="desc" v-model="sortGb" />
					<label for="sortDESC">내림차순</label>
				</div>
			</div>
		</section>

		<!-- msg 문구와 Ok 클릭 시 실행할 함수를 전달한다. -->
		<ModalOKCancel :propData="modalData" @okFunction="modalOKFunction" />
	</section>
</template>

<script>
import ModalOKCancel from '@/components/modal/ModalOKCancel.vue';
import { popOpenAndScrollNone } from '@/utils/UtilPopup';
export default {
	components: {
		ModalOKCancel
	},
	data: () => ({
		modalData: {
			id: 'SettingSortFormModal',
			msg: ''
		},
		sortNm: '',
		sortGb: ''
	}),
	mounted() {
		this.sortNm = this.$store.state.settingInfo.sortNm;
		this.sortGb = this.$store.state.settingInfo.sortGb;
	},
	methods: {
		pageBefore() {
			this.$router.go(-1);
		},
		modalOKFunction() {
			// 서식지 정렬 기준 저장
			console.log('Save');
		},
		changeSort() {
			this.modalData.msg = '저장 되었습니다';

			let json = JSON.stringify({
				sortNm: this.sortNm,
				sortGb: this.sortGb
			});
			this.$util.setOption(json);
			popOpenAndScrollNone(`#${this.modalData.id} .dim-popup-mark`, `#${this.modalData.id} .dim-popup-content`);
		}
	}
};
</script>

<style scoped src="../../assets/css/setting.css"></style>
